(function ($) {


    $(document).on('click', '.collowme-jobs-list-col-a', function (e) {
        e.preventDefault();
        var thisElement = $(this);

        if (!thisElement.hasClass('active')) {
            $(".followme-jobs-single-col").addClass('no-display');
            $("#oferta-" + thisElement.attr('data-slug')).removeClass("no-display");

            $(".collowme-jobs-list-col-a").removeClass("active");
            $(this).addClass("active");

            $([document.documentElement, document.body]).animate({
                scrollTop: $("#oferta-" + thisElement.attr('data-slug')).offset().top - 120
            }, 1000);


            window.history.pushState({urlPath: thisElement.attr("href")}, "", thisElement.attr("href"));
        }

    });


})(jQuery);